import { setSelectedAdmin } from "../../state/adminMasterSlice"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { apiRoute, linksUrl } from "../../constants/enum" 
import { NextUITable, MainContainer, LoadingCard, ErrorCard } from "../../components"
import { useGet } from "../../api/reactQueryCustomHooks"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { ROW_ACTION_BTN_TYPE } from "../../components/NextUITable"

function AdminMaster() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
 

  const onClickEdit = (item) => {
    dispatch(setSelectedAdmin(item))
    navigate(linksUrl.adminMaster.edit)
  }

  const {
    isLoading,
    isError,
    data = [],
  } = useGet({
    url: apiRoute.adminMaster.read,
    queryKey: "AdminMaster",
  })

  const columns = [
    {
      name: "Username",
      uid: "username",
      sortable: true,
    },
    {
      name: "ACTIONS",
      uid: "actions",
    },
  ]

  const INITIAL_VISIBLE_COLUMNS = ["username", "actions"]

  const topActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPlus} />,
      onClick: () => {
        navigate(linksUrl.adminMaster.add)
      },
      label: "Add Admin", 
    },
  ]

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} />,
      onClick: onClickEdit,
      label: "Edit",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  if (isLoading) {
    return (
      <LoadingCard />
    )
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <MainContainer pageName="Admin Master">
      <NextUITable
        INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
        data={data}
        columns={columns}
        exportColumns={columns}
        topActionBtn={topActionBtn}
        rowActionBtn={rowActionBtn}
        downloadFileName="Admin_Master"
        id="party_id"
      />
    </MainContainer>
  )
}

export default AdminMaster
